import React, { useEffect, useState } from "react";
import { HiClock, HiSparkles, HiXMark } from "react-icons/hi2";

interface FirstPurchaseEventCardProps {
  onClose: () => void;
  onClick: () => void;
}

const FirstPurchaseEventCard = ({
  onClose,
  onClick,
}: FirstPurchaseEventCardProps) => {
  const [timeLeft, setTimeLeft] = useState("");

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      const midnight = new Date();
      midnight.setHours(24, 0, 0, 0);

      const diff = midnight.getTime() - now.getTime();

      if (diff <= 0) {
        setTimeLeft("00:00:00");
        return;
      }

      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      const format = (num: number) => (num < 10 ? `0${num}` : num);

      setTimeLeft(`${format(hours)}:${format(minutes)}:${format(seconds)}`);
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClose();
  };

  return (
    <div className="px-4 py-2 bg-white border-b border-gray-100">
      <div
        onClick={onClick}
        className="relative w-full rounded-2xl bg-gradient-to-r from-[#eff4ff] via-white to-[#f7fbff] border border-[#dbe6ff] p-4 shadow-[0_10px_25px_rgba(21,98,252,0.08)] overflow-hidden cursor-pointer active:scale-[0.98] transition-transform"
      >
        <button
          onClick={handleClose}
          className="absolute top-3 right-3 w-6 h-6 flex items-center justify-center rounded-full bg-gray-200/80 hover:bg-gray-300/80 text-gray-600 hover:text-gray-800 transition-colors z-20"
        >
          <HiXMark className="w-4 h-4" />
        </button>

        <div className="absolute -right-4 -top-4 w-28 h-28 bg-[#1562fc]/10 blur-3xl" />

        <div className="flex items-start gap-3 z-10 relative">
          <div className="w-10 h-10 rounded-full bg-[#1562fc] flex items-center justify-center text-white shadow-lg shrink-0">
            <HiSparkles className="w-5 h-5" />
          </div>
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-1">
              <span className="text-xs font-semibold text-[#1562fc] bg-[#1562fc]/10 px-2 py-0.5 rounded-full">
                오늘만 받을 수 있어요
              </span>
              <div className="flex items-center text-xs font-bold text-[#FF5F00]">
                <HiClock className="w-3.5 h-3.5 mr-0.5" />
                {timeLeft}
              </div>
            </div>
            <p className="text-lg font-extrabold text-gray-900 leading-tight">
              첫 구매 감사 쿠폰이 도착했어요! 💌
            </p>
            <p className="text-sm text-gray-500 mt-1">
              지금 바로 눌러서 확인해보세요
            </p>
          </div>
        </div>

        <button className="mt-4 w-full bg-[#1562fc] text-white font-semibold py-3 rounded-xl text-sm shadow-md hover:bg-[#0f4dcf] transition-colors">
          쿠폰 확인하기
        </button>
      </div>
    </div>
  );
};

export default FirstPurchaseEventCard;
